// extracted by mini-css-extract-plugin
module.exports = {"message":"_5yZEZ","small":"D4hwV","icon":"_2gLs3","title":"_9vnUW","description":"_2FTLB"};